import {
  Card,
  Grid,
  Stack,
  TextField,
  FormControlLabel,
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from '@mui/material';
import { Box } from '@mui/system';
import { LoadingButton } from '@mui/lab';
import AutoComplete from '../../../components/AutoComplete';
import MultipleAutoComplete from '../../../components/MultipleAutoComplete';
import { useAppDispatch, useAppSelector } from '../../../store';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { CategoryCake as ICategoryCake } from '../../../store/categoryCake/api/interface';
import { useFormik } from 'formik';
import {
  createCategoryCake,
  getCategoryCake,
  patchCategoryCake,
} from '../../../store/categoryCake/api';
import { setStatus } from '../../../store/categoryCake/categoryCakeSlice';
import { useEffect, useRef, useState } from 'react';
import { decryptString, getAssetURl } from '../../../utils/url';
import Loader from '../../../components/Loader';
import { find, omit, uniqBy } from 'lodash';
import {
  setStatus as selectCategoryCakeSetStatus,
  reset as resetSelectCategoryCakeReset,
} from '../../../store/selectCategoryCake/selectCategoryCakeSlice';
import categoryCakeSchema from '../../../validation/categoryCakeSchema';
import { NumericFormatCustom } from '../../../components/NumericCustomFormatter';
import { MuiColorInput } from 'mui-color-input';
import {
  findSelectShape,
  searchSelectShape,
} from '../../../store/selectShape/api';
import {
  setSkip as setSkipShape,
  reset as resetShape,
} from '../../../store/selectShape/selectShapeSlice';
// import {
//   findSelectFlavor,
//   searchSelectFlavor,
// } from '../../../store/selectFlavor/api';
// import {
//   setSkip as setSkipFlavor,
//   reset as resetFlavor,
// } from '../../../store/selectFlavor/selectFlavorSlice';
// import {
//   findSelectToppingsCategoryItem,
//   searchSelectToppingsCategoryItem,
// } from '../../../store/selectToppingCategoryItem/api';
// import {
//   setSkip as setSkipToppingCategoryItem,
//   reset as resetToppingCategoryItem,
// } from '../../../store/selectToppingCategoryItem/selectToppingCategoryItemSlice';
import {
  findSelectCategory,
  searchSelectCategory,
} from '../../../store/selectCategory/api';
import {
  reset as resetCategory,
  setSkip as setSkipCategory,
} from '../../../store/selectCategory/selectCategorySlice';
import { DISPLAY_MODE } from '../../../constants';
// import { DisplayMode } from '../../../enum';
// import { mergeImages } from '../../../utils/mergeImages';
import { IsNotNullOrEmpty, isValidArray } from '../../../utils/valid';
import { ReadImageItems } from '../../../store/flavor/api/interface';
import { mergeImages } from '../../../utils/mergeImages';
import { DisplayMode } from '../../../enum';
import CloseIcon from '@mui/icons-material/Close';
import { config } from '../../../utils/utils';
import { findSelectFlavorExport } from '../../../store/selectFlavorExport/api';
import { findSelectToppingsCategoryItemExport } from '../../../store/selectToppingCategoryItemExport/api';
import { Shape, Flavor, ToppingsCategoryItem } from '../../../client/services';

const CategoryCakeForm = () => {
  const dispatch = useAppDispatch();
  const navigation = useNavigate();
  const params: any = useParams();
  const location = useLocation();
  const state = location.state as ICategoryCake; // Type Casting, then you can get the params passed via router

  const isAddMode = !params?.id;
  const { isLoading } = useAppSelector((state) => state.categoryCake);
  const [response, setResponse] = useState<any>();
  const [categorySearch, setCategorySearch] = useState('');
  const [allCategories, setAllCategories] = useState<any[]>([]);
  
  // Ref to prevent infinite loops
  const hasTriggeredRefresh = useRef(false);
  

  



  const [mergedImageUrl, setMergedImageUrl] = useState<any>();
  const [filteredFlavors, setFilteredFlavors] = useState<any>([]);

  const assetUrl = useAppSelector(
    (state) => state.active.selectedItem.assetUrl
  );

  const {
    handleSubmit,
    values,
    setValues,
    handleChange,
    setFieldValue,
    resetForm,
    isSubmitting,
    errors,
    touched,
  } = useFormik({
    initialValues: {
      id: '',
      labelEn: '',
      labelAr: '',
      descriptionEn: '',
      descriptionAr: '',
      colorCode: '',
      displayBackgroundColor: config.DEFAULT_COLOR,
      // displayCss: '',
      displayMode: '',
      shapeId: '',
      flavorId: '',
      toppingId: '',
      position: '',
      categoryId: '',
      additionalCategoryIds: [] as string[],
      // isSoldOut: false,
      isNew: false,
      activeState: true,
      isMostLoved: false,
      isBig: false,
    },
    validationSchema: categoryCakeSchema,
    onSubmit: async (values) => {
      try {
        if (isAddMode) {
          const reqBody = omit(values, ['id']);
          await dispatch(createCategoryCake(reqBody)).unwrap();
        }
        if (!isAddMode) {
          const reqBody: any = values;
          delete reqBody.createdAt;
          delete reqBody.createdBy;
          delete reqBody.updatedAt;
          delete reqBody.updatedBy;
          delete reqBody.category;
          delete reqBody.flavor;
          delete reqBody.shape;
          delete reqBody.topping_category_item;
          // Remove computed fields that shouldn't be sent to backend
          delete reqBody.additionalCategories;
          delete reqBody.allCategories;
          delete reqBody.categoryCount;
          delete reqBody.isBestSeller;
          delete reqBody.isTrending;
          delete reqBody.badges;
          delete reqBody.bestSellerScore;
          delete reqBody.trendingScore;
          delete reqBody.badgesUpdatedAt;
          delete reqBody.estimatedRewardPoints;
          await dispatch(patchCategoryCake(reqBody)).unwrap();
        }
        resetForm();
        dispatch(setStatus({ status: 'idle' }));
        dispatch(resetSelectCategoryCakeReset());
        dispatch(selectCategoryCakeSetStatus({ status: 'idle' }));
        navigation('/occasion-cake');
      } catch (error: any) {}
    },
  });

  useEffect(() => {
    const fetchById = async () => {
      if (isAddMode) return;

      if (state) {
        const stateWithAdditionalCategoryIds = {
          ...state,
          additionalCategoryIds: state.additionalCategoryIds || [],
          displayBackgroundColor:
            !state.displayBackgroundColor ||
            state.displayBackgroundColor.toLowerCase() === '#f9f6f3'
              ? config.DEFAULT_COLOR
              : state.displayBackgroundColor,
        };
        console.log("Edit Mode - Using state data:", state);
        console.log("Edit Mode - State additional category IDs:", state.additionalCategoryIds);
        setValues(stateWithAdditionalCategoryIds);
        setResponse(state);
        
        // Note: Categories will be reconstructed later when categoryData loads
        console.log("State mode - Primary category ID:", state.categoryId);
        console.log("State mode - Additional category IDs:", state.additionalCategoryIds);
        
        // Ensure categories are loaded for additional categories display
        if (state?.additionalCategoryIds && state.additionalCategoryIds.length > 0 && categoryData.length === 0) {
          console.log("Loading categories for additional category display from state");
          dispatch(findSelectCategory({}));
        }
        
        // Force refresh image after setting data
        setTimeout(() => {
          setForceRefresh(prev => prev + 1);
        }, 500);
      } else {
        try {
          const decodeParam = decryptString(params.id);
          const record = await dispatch(
            getCategoryCake({ id: decodeParam })
          ).unwrap();
          
          console.log("Edit Mode - API Response:", record);
          console.log("Additional Category IDs from API:", record?.additionalCategoryIds);
          console.log("Additional Categories from API:", record?.additionalCategories);
          
          // Log the extracted category objects
          if (record?.additionalCategories) {
            const extractedCategories = record.additionalCategories.map((ac: any) => ac.category);
            console.log("Extracted category objects:", extractedCategories);
          }
          
          // Ensure we're preserving the nested objects appropriately
          const formValues = {
            ...record,
            shapeId: record?.shape?.id || record?.shapeId || '',
            flavorId: record?.flavor?.id || record?.flavorId || '',
            toppingId: record?.topping_category_item?.id || record?.toppingId || '',
            categoryId: record?.category?.id || record?.categoryId || '',
            additionalCategoryIds: record?.additionalCategoryIds || [],
            displayMode: record?.displayMode || DisplayMode.front, // Default to front if not set
            displayBackgroundColor:
              !record?.displayBackgroundColor ||
              record.displayBackgroundColor.toLowerCase() === '#f9f6f3'
                ? config.DEFAULT_COLOR
                : record.displayBackgroundColor,
          };

          const primaryCategory = record.category;
          const additionalCategories = record.additionalCategories?.map((ac: any) => ac.category) || [];
          if (primaryCategory) {
            setAllCategories([primaryCategory, ...additionalCategories]);
          }
          
          console.log("Setting form values:", formValues);
          setValues(formValues);
          
          setResponse(record);
          
          // Force refresh image after setting data
          setTimeout(() => {
            setForceRefresh(prev => prev + 1);
          }, 800);
          
          // Ensure categories are loaded for additional categories display
          if (record?.additionalCategoryIds && record.additionalCategoryIds.length > 0 && categoryData.length === 0) {
            console.log("Loading categories for additional category display");
            dispatch(findSelectCategory({}));
          }
        } catch (error: any) {
          console.error("Error fetching category cake:", error);
          navigation('/occasion-cake');
        }
      }
    };
    fetchById();
  }, [dispatch, isAddMode, navigation, params?.id, setValues, state]);

  // Shape Data
  const {
    data: shapeData,
    isLoading: isShapeLoading,
    skip: shapeSkip,
    hasMore: shapeHasMore,
    status: shapeStatus,
  } = useAppSelector((state) => state.selectShape);

  useEffect(() => {
    if (shapeStatus === 'idle') {
      dispatch(
        findSelectShape({
          limit: 50,
          skip: shapeSkip,
        })
      );
    }
  }, [shapeSkip, shapeStatus]);

  const onScrollFetchShape = (
    e: React.UIEvent<HTMLUListElement, UIEvent>,
    search: string
  ) => {
    if (
      e.currentTarget.scrollTop + 300 >= e.currentTarget.scrollHeight &&
      shapeHasMore
    ) {
      dispatch(setSkipShape({ skip: shapeSkip + 10 }));
      dispatch(
        findSelectShape({
          limit: 50,
          skip: shapeSkip + 10,
          ...(search && { search: search }),
        })
      );
    }
  };

  const searchShape = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (!e.target.value) {
      dispatch(resetShape());
      return;
    }
    const params = {
      ...(!e.target.value && { limit: 50 }),
      ...(!e.target.value && { skip: 0 }),
      ...(e.target.value && { search: e.target.value }),
    };
    dispatch(setSkipShape({ skip: 0 }));
    dispatch(searchSelectShape(params));
  };

  // const shapeDetails =
  //   response?.shapeImages?.map((item) => {
  //     return item?.shape;
  //   }) ?? [];

  const uniqueShapeData = uniqBy(
    [...(response?.shape ? [response?.shape] : []), ...shapeData],
    'id'
  );

  // Flavor Data
  const {
    data: flavorData,
    isLoading: isFlavorLoading,
    // skip: flavorSkip,
    // hasMore: flavorHasMore,
    status: flavorStatus,
  } = useAppSelector((state) => state.selectFlavorExport);

  useEffect(() => {
    if (flavorStatus === 'idle') {
      dispatch(
        findSelectFlavorExport({
          isExport: true,
          // limit: 10,
          // skip: flavorSkip,
        })
      );
    }
  }, [flavorStatus]);

  // const onScrollFetchFlavor = (
  //   e: React.UIEvent<HTMLUListElement, UIEvent>,
  //   search: string
  // ) => {
  //   if (
  //     e.currentTarget.scrollTop + 300 >= e.currentTarget.scrollHeight &&
  //     flavorHasMore
  //   ) {
  //     dispatch(setSkipFlavor({ skip: flavorSkip + 10 }));
  //     dispatch(
  //       findSelectFlavor({
  //         limit: 10,
  //         skip: flavorSkip + 10,
  //         ...(search && { search: search }),
  //       })
  //     );
  //   }
  // };

  // const searchFlavor = (
  //   e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  // ) => {
  //   if (!e.target.value) {
  //     dispatch(resetFlavor());
  //     return;
  //   }
  //   const params = {
  //     ...(!e.target.value && { limit: 10 }),
  //     ...(!e.target.value && { skip: 0 }),
  //     ...(e.target.value && { search: e.target.value }),
  //   };
  //   dispatch(setSkipFlavor({ skip: 0 }));
  //   dispatch(searchSelectFlavor(params));
  // };

  const uniqueFlavorData = uniqBy(
    [
      ...(response?.flavor ? [response?.flavor] : []),
      ...(isValidArray(filteredFlavors) || filteredFlavors?.length === 0
        ? [...filteredFlavors]
        : [...flavorData]),
    ],
    'id'
  );

  // Topping Category Item Data
  const {
    data: toppingCategoryItemData,
    isLoading: isToppingCategoryItemLoading,
    hasMore: toppingCategoryItemHasMore,
    status: toppingCategoryItemStatus,
  } = useAppSelector((state) => state.selectToppingCategoryItemExport);

  useEffect(() => {
    if (toppingCategoryItemStatus === 'idle') {
      dispatch(
        findSelectToppingsCategoryItemExport({
          isExport: true,
          limit: 100,
          skip: 0,
        })
      );
    }
  }, [dispatch, toppingCategoryItemStatus]);

  const onScrollFetchToppingCategoryItem = (
    e: React.UIEvent<HTMLUListElement, UIEvent>,
    search: string
  ) => {
    if (
      e.currentTarget.scrollTop + 300 >= e.currentTarget.scrollHeight &&
      toppingCategoryItemHasMore
    ) {
      dispatch(
        findSelectToppingsCategoryItemExport({
          isExport: true,
          limit: 50,
          skip: (toppingCategoryItemData?.length || 0),
          ...(search && { search: search }),
        })
      );
    }
  };

  const searchToppingCategoryItem = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (!e.target.value) {
      dispatch(
        findSelectToppingsCategoryItemExport({
          isExport: true,
          limit: 100,
          skip: 0,
        })
      );
      return;
    }
    dispatch(
      findSelectToppingsCategoryItemExport({
        isExport: true,
        limit: 100,
        skip: 0,
        search: e.target.value,
      })
    );
  };

  const uniqueToppingCategoryItemData = uniqBy(
    [
      ...(response?.topping_category_item ? [response?.topping_category_item] : []),
      ...(toppingCategoryItemData || [])
    ],
    'id'
  );

  // Category Data
  const {
    data: categoryData,
    isLoading: isCategoryLoading,
    skip: categorySkip,
    hasMore: categoryHasMore,
    status: categoryStatus,
  } = useAppSelector((state) => state.selectCategory);



  useEffect(() => {
    if (categoryStatus === 'idle') {
      dispatch(
        findSelectCategory({
          limit: 10,
          skip: categorySkip,
        })
      );
    }
  }, [categorySkip, categoryStatus]);

  const onScrollFetchCategory = (
    e: React.UIEvent<HTMLUListElement, UIEvent>,
    search: string
  ) => {
    if (
      e.currentTarget.scrollTop + 300 >= e.currentTarget.scrollHeight &&
      categoryHasMore
    ) {
      dispatch(setSkipCategory({ skip: categorySkip + 10 }));
      dispatch(
        findSelectCategory({
          limit: 10,
          skip: categorySkip + 10,
          ...(search && { search: search }),
        })
      );
    }
  };

  const searchCategory = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setCategorySearch(e.target.value);
    if (!e.target.value) {
      dispatch(resetCategory());
      return;
    }
    const params = {
      ...(!e.target.value && { limit: 10 }),
      ...(!e.target.value && { skip: 0 }),
      ...(e.target.value && { search: e.target.value }),
    };
    dispatch(setSkipCategory({ skip: 0 }));
    dispatch(searchSelectCategory(params));
  };

  const uniqueCategoryData = uniqBy(
    [
      ...(response?.category ? [response?.category] : []), 
      ...(response?.additionalCategories ? response.additionalCategories.map((ac: any) => ac.category) : []),
      ...categoryData
    ],
    'id'
  );

  // Simple fix: Always use fresh categoryData only
  const dropdownOptions = categoryData;

  // Only reconstruct for edit mode when data loads
  useEffect(() => {
    if (!isAddMode && values.categoryId && uniqueCategoryData?.length > 0 && !hasTriggeredRefresh.current) {
      const primaryCategory = uniqueCategoryData.find((cat: any) => cat.id === values.categoryId);
      const additionalCategories = uniqueCategoryData.filter((cat: any) => values.additionalCategoryIds?.includes(cat.id));
      
      if (primaryCategory) {
        setAllCategories([primaryCategory, ...additionalCategories]);
        hasTriggeredRefresh.current = true;
      }
    }
  }, [isAddMode, values.categoryId, values.additionalCategoryIds, uniqueCategoryData]);

  // Reset when switching modes
  useEffect(() => {
    hasTriggeredRefresh.current = false;
    if (isAddMode) {
      setAllCategories([]);
    }
  }, [isAddMode, params.id]);

  // Load categories once for edit mode
  useEffect(() => {
    if (!isAddMode) {
      console.log("Loading categories for edit mode");
      dispatch(findSelectCategory({ limit: 50 }));
    }
  }, [isAddMode, dispatch]);



  useEffect(() => {
    if (IsNotNullOrEmpty(values?.shapeId)) {
      const filteredFlavor = flavorData?.filter((flavor) =>
        flavor?.shapeImages?.some(
          (shapeImage: ReadImageItems) =>
            shapeImage?.shapeId === values?.shapeId
        )
      );
      setFilteredFlavors(filteredFlavor);
    } else {
      setFilteredFlavors([]);
    }
  }, [values?.shapeId, flavorData]);

  // Add an effect to update the shapeId, flavorId and toppingId when in edit mode
  useEffect(() => {
    if (!isAddMode && response) {
      if (response.shape && !values.shapeId) {
        setFieldValue('shapeId', response.shape.id);
      }
      if (response.flavor && !values.flavorId) {
        setFieldValue('flavorId', response.flavor.id);
      }
      if (response.topping_category_item && !values.toppingId) {
        setFieldValue('toppingId', response.topping_category_item.id);
      }
      if (response.category && !values.categoryId) {
        setFieldValue('categoryId', response.category.id);
      }
    }
  }, [isAddMode, response, values.shapeId, values.flavorId, values.toppingId, values.categoryId, setFieldValue]);

  const boxRef = useRef<HTMLDivElement>(null);
  const [openLightBox, setOpenLightBox] = useState(false);
  const [imageState, setImageState] = useState<string>();
  const [forceRefresh, setForceRefresh] = useState(0);

  const handleOpenLightBox = (imageObject: string) => {
    setOpenLightBox(true);
    setImageState(imageObject);
  };

  const handleCloseLightBox = () => {
    setOpenLightBox(false);
    setImageState('');
  };

  const handleForceRefresh = () => {
    setForceRefresh(prev => prev + 1);
  };

  // Add state for directly fetched shape/flavor/topping data
  const [completeShapeData, setCompleteShapeData] = useState(null);
  const [completeFlavorData, setCompleteFlavorData] = useState(null);
  const [completeToppingData, setCompleteToppingData] = useState(null);
  
  // Function to fetch complete data for selected items
  const fetchCompleteData = async () => {
    try {
      if (values?.shapeId) {
        console.log("Fetching complete shape data for ID:", values.shapeId);
        const shapeResponse = await Shape.get(values.shapeId);
        console.log("Complete shape data:", shapeResponse);
        setCompleteShapeData(shapeResponse);
      }
      
      if (values?.flavorId) {
        console.log("Fetching complete flavor data for ID:", values.flavorId);
        const flavorResponse = await Flavor.get(values.flavorId);
        console.log("Complete flavor data:", flavorResponse);
        setCompleteFlavorData(flavorResponse);
      }
      
      if (values?.toppingId) {
        console.log("Fetching complete topping data for ID:", values.toppingId);
        const toppingResponse = await ToppingsCategoryItem.get(values.toppingId);
        console.log("Complete topping data:", toppingResponse);
        setCompleteToppingData(toppingResponse);
      }
    } catch (error) {
      console.error("Error fetching complete data:", error);
    }
  };
  
  // Trigger data fetch when shape/flavor/topping IDs change
  useEffect(() => {
    if (values?.shapeId || values?.flavorId || values?.toppingId) {
      fetchCompleteData();
      
      // Automatically refresh the image when any of these values change
      const timer = setTimeout(() => {
        setForceRefresh(prev => prev + 1);
      }, 300);
      
      return () => clearTimeout(timer);
    }
  }, [values?.shapeId, values?.flavorId, values?.toppingId, values?.displayMode]);

  // When we refresh the image and have complete data available
  useEffect(() => {
    if (forceRefresh > 0) {
      console.log("Force refreshing image...", {
      shapeId: values?.shapeId,
        flavorId: values?.flavorId,
        toppingId: values?.toppingId,
        displayMode: values?.displayMode
      });
      
      // Only attempt if we have the necessary data
      if (!values?.shapeId || !values?.displayMode) {
        console.log("Cannot refresh - missing required data");
        return;
      }

      const timer = setTimeout(async () => {
        try {
          // Find shape - check in various sources with priority to the directly fetched data
          const shape = completeShapeData || 
                       find(uniqueShapeData, { id: values.shapeId }) || 
                       response?.shape || 
                       (response?.shape?.id === values.shapeId ? response.shape : null);
          
          if (!shape) {
            console.log("Shape not found for refresh. Available shapes:", 
              uniqueShapeData?.map(s => ({id: s.id, label: s.labelEn})));
            console.log("Response shape:", response?.shape);
            return;
          }
          
          console.log("Found shape:", shape);
          console.log("Shape image details:", {
            frontImg: shape?.frontImg,
            topImg: shape?.topImg,
            frontColorImg: shape?.frontColorImg,
            topColorImg: shape?.topColorImg
          });
          
          // Find flavor - check in various sources with priority to the directly fetched data
          const flavor = completeFlavorData ||
                        find(uniqueFlavorData, { id: values.flavorId }) || 
                        response?.flavor || 
                        (response?.flavor?.id === values.flavorId ? response.flavor : null);
          
          console.log("Found flavor:", flavor);
          console.log("Flavor shapeImages:", flavor?.shapeImages);
          
          // Find flavor shape image
          const flavorShape = flavor?.shapeImages?.find(
            (img: any) => img?.shapeId === values.shapeId
          );
          
          console.log("Found flavorShape:", flavorShape);
          
          // Find topping - check in various sources with priority to the directly fetched data
          const topping = completeToppingData ||
                         find(uniqueToppingCategoryItemData, { id: values.toppingId }) || 
                         response?.topping_category_item || 
                         (response?.topping_category_item?.id === values.toppingId ? response.topping_category_item : null);
          
          console.log("Found topping:", topping);
          console.log("Topping toppingShapeImages:", topping?.toppingShapeImages);
          
          // Find topping shape image
          const toppingShape = topping?.toppingShapeImages?.find(
            (img: any) => img?.shapeId === values.shapeId
          );
          
          console.log("Found toppingShape:", toppingShape);
          
          // Get URLs with proper error checking
          let shapeUrl = '', flavorUrl = '', toppingUrl = '', colorImgUrl = '';
          
          if (values.displayMode === DisplayMode.front) {
            // Get shape front image
            if (shape?.frontImg && shape.frontImg.trim() !== '') {
              shapeUrl = getAssetURl(shape.frontImg, assetUrl);
              console.log("Shape front URL:", { key: shape.frontImg, url: shapeUrl });
            } else {
              console.warn("No frontImg found in shape:", shape);
            }
            
            // Get flavor front image
            if (flavorShape?.front && flavorShape.front.trim() !== '') {
              flavorUrl = getAssetURl(flavorShape.front, assetUrl);
              console.log("Flavor front URL:", { key: flavorShape.front, url: flavorUrl });
            } else if (flavor?.frontImg && flavor.frontImg.trim() !== '') {
              // Fallback to flavor.frontImg if flavorShape is not available
              flavorUrl = getAssetURl(flavor.frontImg, assetUrl);
              console.log("Fallback flavor front URL:", { key: flavor.frontImg, url: flavorUrl });
            } else {
              console.warn("No front image found for flavor");
            }
            
            // Get topping front image
            if (toppingShape?.front && toppingShape.front.trim() !== '') {
              toppingUrl = getAssetURl(toppingShape.front, assetUrl);
              console.log("Topping front URL:", { key: toppingShape.front, url: toppingUrl });
            } else if (topping?.frontImg && topping.frontImg.trim() !== '') {
              // Fallback to topping.frontImg if toppingShape is not available
              toppingUrl = getAssetURl(topping.frontImg, assetUrl);
              console.log("Fallback topping front URL:", { key: topping.frontImg, url: toppingUrl });
            } else {
              console.warn("No front image found for topping");
            }
            
            // Get shape front color image
            if (shape?.frontColorImg && shape.frontColorImg.trim() !== '') {
              colorImgUrl = getAssetURl(shape.frontColorImg, assetUrl);
              console.log("Color front URL:", { key: shape.frontColorImg, url: colorImgUrl });
            }
          } else {
            // Get shape top image
            if (shape?.topImg && shape.topImg.trim() !== '') {
              shapeUrl = getAssetURl(shape.topImg, assetUrl);
              console.log("Shape top URL:", { key: shape.topImg, url: shapeUrl });
            } else {
              console.warn("No topImg found in shape:", shape);
            }
            
            // Get flavor top image
            if (flavorShape?.top && flavorShape.top.trim() !== '') {
              flavorUrl = getAssetURl(flavorShape.top, assetUrl);
              console.log("Flavor top URL:", { key: flavorShape.top, url: flavorUrl });
            } else if (flavor?.topImg && flavor.topImg.trim() !== '') {
              // Fallback to flavor.topImg if flavorShape is not available
              flavorUrl = getAssetURl(flavor.topImg, assetUrl);
              console.log("Fallback flavor top URL:", { key: flavor.topImg, url: flavorUrl });
            } else {
              console.warn("No top image found for flavor");
            }
            
            // Get topping top image
            if (toppingShape?.top && toppingShape.top.trim() !== '') {
              toppingUrl = getAssetURl(toppingShape.top, assetUrl);
              console.log("Topping top URL:", { key: toppingShape.top, url: toppingUrl });
            } else if (topping?.topImg && topping.topImg.trim() !== '') {
              // Fallback to topping.topImg if toppingShape is not available
              toppingUrl = getAssetURl(topping.topImg, assetUrl);
              console.log("Fallback topping top URL:", { key: topping.topImg, url: toppingUrl });
            } else {
              console.warn("No top image found for topping");
            }
            
            // Get shape top color image
            if (shape?.topColorImg && shape.topColorImg.trim() !== '') {
              colorImgUrl = getAssetURl(shape.topColorImg, assetUrl);
              console.log("Color top URL:", { key: shape.topColorImg, url: colorImgUrl });
            }
          }
          
          console.log("Generating image with URLs:", { 
              shapeUrl,
              flavorUrl,
              toppingUrl,
            colorImgUrl,
            shape: values.displayMode === DisplayMode.front ? shape?.frontImg : shape?.topImg,
            flavor: values.displayMode === DisplayMode.front ? flavorShape?.front || flavor?.frontImg : flavorShape?.top || flavor?.topImg,
            topping: values.displayMode === DisplayMode.front ? toppingShape?.front || topping?.frontImg : toppingShape?.top || topping?.topImg,
            assetUrl
          });
          
          // Directly check if we have a valid shape URL
          if (!shapeUrl || shapeUrl.trim() === '') {
            console.warn("No shape URL available - attempting direct image generation with default values");
            
            // Get direct image keys from object
            const shapeImgKey = values.displayMode === DisplayMode.front ? shape?.frontImg : shape?.topImg;
            const flavorImgKey = values.displayMode === DisplayMode.front ? 
              (flavorShape?.front || flavor?.frontImg) : 
              (flavorShape?.top || flavor?.topImg);
            const toppingImgKey = values.displayMode === DisplayMode.front ? 
              (toppingShape?.front || topping?.frontImg) : 
              (toppingShape?.top || topping?.topImg);
            const colorImgKey = values.displayMode === DisplayMode.front ? shape?.frontColorImg : shape?.topColorImg;
            
            console.log("Attempting with direct image keys:", { shapeImgKey, flavorImgKey, toppingImgKey, colorImgKey });
            
            if (shapeImgKey && shapeImgKey.trim() !== '') {
              shapeUrl = getAssetURl(shapeImgKey, assetUrl);
              console.log("Direct shape URL:", shapeUrl);
              
              if (flavorImgKey && flavorImgKey.trim() !== '') {
                flavorUrl = getAssetURl(flavorImgKey, assetUrl);
              }
              
              if (toppingImgKey && toppingImgKey.trim() !== '') {
                toppingUrl = getAssetURl(toppingImgKey, assetUrl);
              }
              
              if (colorImgKey && colorImgKey.trim() !== '') {
                colorImgUrl = getAssetURl(colorImgKey, assetUrl);
              }
            }
          }
          
          if (shapeUrl && shapeUrl.trim() !== '') {
            try {
              console.log("Calling mergeImages with:", {
                shapeUrl,
                flavorUrl: flavorUrl || '',
                colorCode: values.colorCode || '',
                toppingUrl: toppingUrl || '',
                colorImgUrl: colorImgUrl || ''
              });
              
              const merged = await mergeImages(
                shapeUrl,
                flavorUrl || '',
                values.colorCode || '',
                toppingUrl || '',
                colorImgUrl || ''
              );
              
              if (merged) {
                console.log("Successfully refreshed image");
                setMergedImageUrl(merged);
              } else {
                console.warn("Failed to generate merged image, using placeholder");
                setMergedImageUrl('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=');
              }
            } catch (error) {
              console.error("Image merging error:", error);
              setMergedImageUrl('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=');
            }
          } else {
            console.warn("No shape URL available, using placeholder");
            setMergedImageUrl('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=');
        }
      } catch (error) {
          console.error("Error during image refresh:", error);
          setMergedImageUrl('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=');
        }
      }, 200);
      
      return () => clearTimeout(timer);
    }
  }, [
    forceRefresh,
    values?.shapeId,
    values?.flavorId,
    values?.toppingId,
    values?.colorCode,
    values?.displayMode,
    uniqueShapeData,
    uniqueFlavorData,
    uniqueToppingCategoryItemData,
    completeShapeData,
    completeFlavorData, 
    completeToppingData,
    assetUrl,
    response
  ]);

  return (
    <>
      <Grid
        container
        spacing={3}
      >
        <Grid
          item
          xs={12}
          md={12}
        >
          {isLoading ? (
            <Loader />
          ) : (
            <form onSubmit={handleSubmit}>
              <Card sx={{ p: 3 }}>
                <Box
                  sx={{
                    display: 'grid',
                    columnGap: 2,
                    rowGap: 3,
                    gridTemplateColumns: {
                      xs: 'repeat(1, 1fr)',
                      sm: 'repeat(2, 1fr)',
                    },
                  }}
                >
                  <TextField
                    fullWidth
                    label={'Label English'}
                    name='labelEn'
                    id='labelEn'
                    onChange={handleChange}
                    value={values.labelEn}
                    error={Boolean(errors.labelEn && touched.labelEn)}
                    helperText={
                      Boolean(errors.labelEn && touched.labelEn) &&
                      errors.labelEn
                    }
                  />
                  <TextField
                    fullWidth
                    label={'Label Arabic'}
                    name='labelAr'
                    id='labelAr'
                    onChange={handleChange}
                    value={values.labelAr}
                    error={Boolean(errors.labelAr && touched.labelAr)}
                    helperText={
                      Boolean(errors.labelAr && touched.labelAr) &&
                      errors.labelAr
                    }
                  />

                  <AutoComplete
                    key={`shapeId-${values?.shapeId}`}
                    onChange={(event, newValue) => {
                      if (typeof newValue === 'string') {
                      } else if (newValue) {
                        setFieldValue('shapeId', newValue.id);
                        setFieldValue('toppingId', '');
                        setFieldValue('flavorId', '');
                      }
                    }}
                    onInputChange={(event, newInputValue) => {
                      if (!newInputValue) {
                        setFieldValue('shapeId', '');
                        setFieldValue('toppingId', '');
                        setFieldValue('flavorId', '');
                      }
                    }}
                    renderOption={(props, option) => (
                      <li {...props}>{option.labelEn}</li>
                    )}
                    getOptionLabel={(option) => option.labelEn}
                    error={Boolean(touched.shapeId && errors.shapeId)}
                    helperText={
                      Boolean(touched.shapeId && errors.shapeId)
                        ? errors.shapeId
                        : ''
                    }
                    fetchFunction={onScrollFetchShape}
                    label={'Select Shape'}
                    loading={isShapeLoading}
                    options={uniqueShapeData}
                    searchFunction={searchShape}
                    value={
                      uniqueShapeData?.filter(
                        (shape) => shape.id === values.shapeId
                      )?.[0] || null
                    }
                  />

                  <AutoComplete
                    key={`flavorId-${values?.flavorId}`}
                    onChange={(event, newValue) => {
                      if (typeof newValue === 'string') {
                      } else if (newValue) {
                        setFieldValue('flavorId', newValue.id);
                      }
                    }}
                    onInputChange={(event, newInputValue) => {
                      if (!newInputValue) {
                        setFieldValue('flavorId', '');
                      }
                    }}
                    renderOption={(props, option) => (
                      <li {...props}>{option.labelEn}</li>
                    )}
                    getOptionLabel={(option) => option.labelEn}
                    error={Boolean(touched.flavorId && errors.flavorId)}
                    helperText={
                      Boolean(touched.flavorId && errors.flavorId)
                        ? errors.flavorId
                        : ''
                    }
                    // fetchFunction={onScrollFetchFlavor}
                    fetchFunction={() => null}
                    label={'Select Flavor'}
                    loading={isFlavorLoading}
                    options={uniqueFlavorData}
                    searchFunction={() => null}
                    // searchFunction={searchFlavor}
                    value={
                      uniqueFlavorData?.filter(
                        (flavor) => flavor.id === values.flavorId
                      )?.[0] || null
                    }
                  />

                  <AutoComplete
                    key={`toppingId-${values?.toppingId}`}
                    onChange={(event, newValue) => {
                      if (typeof newValue === 'string') {
                      } else if (newValue) {
                        setFieldValue('toppingId', newValue.id);
                      }
                    }}
                    onInputChange={(event, newInputValue) => {
                      if (!newInputValue) {
                        setFieldValue('toppingId', '');
                      }
                    }}
                    renderOption={(props, option) => (
                      <li {...props}>{option.labelEn}</li>
                    )}
                    getOptionLabel={(option) => option.labelEn}
                    error={Boolean(touched.toppingId && errors.toppingId)}
                    helperText={
                      Boolean(touched.toppingId && errors.toppingId)
                        ? errors.toppingId
                        : ''
                    }
                    fetchFunction={onScrollFetchToppingCategoryItem}
                    label={'Select Toppings Category'}
                    loading={isToppingCategoryItemLoading}
                    options={uniqueToppingCategoryItemData}
                    searchFunction={searchToppingCategoryItem}
                    value={
                      uniqueToppingCategoryItemData?.filter(
                        (toppingsCategory) =>
                          toppingsCategory.id === values.toppingId
                      )?.[0] || null
                    }
                  />

                  <MultipleAutoComplete
                    label='Occasion'
                    options={dropdownOptions}
                    loading={isCategoryLoading}
                    value={allCategories}
                    key={`categories-${allCategories.length}-${values.categoryId}`}
                    onChange={(e, value) => {
                      // Remove duplicates based on category ID
                      const uniqueCategories: any[] = [];
                      const seenIds = new Set<string>();
                      
                      if (value) {
                        value.forEach((category: any) => {
                          if (category?.id && !seenIds.has(category.id)) {
                            seenIds.add(category.id);
                            uniqueCategories.push(category);
                          }
                        });
                      }
                      
                      setAllCategories(uniqueCategories);
                      
                      if (uniqueCategories && uniqueCategories.length > 0) {
                        setFieldValue('categoryId', uniqueCategories[0].id);
                        const additionalIds = uniqueCategories.slice(1).map((v: any) => v.id);
                        setFieldValue('additionalCategoryIds', additionalIds);
                      } else {
                        // Clear everything immediately
                        setAllCategories([]);
                        setFieldValue('categoryId', '');
                        setFieldValue('additionalCategoryIds', []);
                      }
                    }}
                    onInputChange={(_event, _newInputValue) => {
                      // Handle input change for search
                    }}
                    renderOption={(props, option: any) => (
                      <li {...props}>{option.labelEn}</li>
                    )}
                    getOptionLabel={(option: any) => option.labelEn}
                    isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                    error={Boolean(touched.categoryId && errors.categoryId)}
                                                              helperText={
                      touched.categoryId && errors.categoryId
                        ? errors.categoryId
                        : ''
                    }
                    fetchFunction={(e) => onScrollFetchCategory(e, categorySearch)}
                    searchFunction={searchCategory}
                    limitTags={3}
                  />

                  <MuiColorInput
                    label='Select Color Code'
                    format='hex'
                    value={values?.colorCode}
                    onChange={(newColor: string) =>
                      setFieldValue('colorCode', newColor)
                    }
                    error={Boolean(errors.colorCode && touched.colorCode)}
                    helperText={
                      Boolean(errors.colorCode && touched.colorCode) &&
                      errors.colorCode
                    }
                  />

                  <MuiColorInput
                    label='Select Background Color'
                    format='hex'
                    value={values?.displayBackgroundColor}
                    onChange={(newColor: string) =>
                      setFieldValue('displayBackgroundColor', newColor)
                    }
                    error={Boolean(
                      errors.displayBackgroundColor &&
                        touched.displayBackgroundColor
                    )}
                    helperText={
                      Boolean(
                        errors.displayBackgroundColor &&
                          touched.displayBackgroundColor
                      ) && errors.displayBackgroundColor
                    }
                  />

                  <FormControl
                    fullWidth
                    error={Boolean(touched?.displayMode && errors?.displayMode)}
                  >
                    <InputLabel>{'Display Mode'}</InputLabel>
                    <Select
                      name='displayMode'
                      labelId='displayMode'
                      id='displayMode'
                      value={values.displayMode}
                      label={'Display Mode'}
                      onChange={(e) => {
                        setFieldValue('displayMode', e.target.value);
                        // Automatically refresh when display mode changes
                        setTimeout(() => setForceRefresh(prev => prev + 1), 200);
                      }}
                      MenuProps={{
                        style: {
                          maxHeight: 400,
                        },
                      }}
                    >
                      {DISPLAY_MODE?.map((mode) => (
                        <MenuItem
                          key={mode.value}
                          value={mode.value}
                        >
                          {mode.name}
                        </MenuItem>
                      ))}
                    </Select>
                    {Boolean(touched.displayMode && errors.displayMode) && (
                      <FormHelperText>{errors?.displayMode}</FormHelperText>
                    )}
                  </FormControl>

                  <TextField
                    fullWidth
                    label={'Position'}
                    name='position'
                    id='position'
                    onChange={handleChange}
                    InputProps={{
                      inputComponent: NumericFormatCustom as any,
                    }}
                    value={values.position}
                    error={Boolean(errors.position && touched.position)}
                    helperText={
                      Boolean(errors.position && touched.position) &&
                      errors?.position
                    }
                  />
                </Box>

                <Box sx={{ pt: 2.5 }}>
                  <TextField
                    fullWidth
                    label={'English Description'}
                    name='descriptionEn'
                    id='descriptionEn'
                    onChange={handleChange}
                    value={values.descriptionEn}
                    error={Boolean(
                      errors.descriptionEn && touched.descriptionEn
                    )}
                    helperText={
                      Boolean(errors.descriptionEn && touched.descriptionEn) &&
                      errors.descriptionEn
                    }
                  />
                </Box>

                <Box sx={{ pt: 2.5, pb: 2.5 }}>
                  <TextField
                    fullWidth
                    label={'Arabic Description'}
                    name='descriptionAr'
                    id='descriptionAr'
                    onChange={handleChange}
                    value={values.descriptionAr}
                    error={Boolean(
                      errors.descriptionAr && touched.descriptionAr
                    )}
                    helperText={
                      Boolean(errors.descriptionAr && touched.descriptionAr) &&
                      errors.descriptionAr
                    }
                  />
                </Box>

                <Grid
                  container
                  spacing={2}
                  py={2}
                >
                  <Grid
                    item
                    xs={12}
                    sm={3}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          color='primary'
                          name='activeState'
                          onChange={(e) =>
                            setFieldValue('activeState', e.target.checked)
                          }
                          checked={values.activeState}
                          sx={{ '& .MuiSvgIcon-root': { fontSize: 70 } }}
                        />
                      }
                      label={'Active Status'}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          color='primary'
                          name='isNew'
                          onChange={(e) =>
                            setFieldValue('isNew', e.target.checked)
                          }
                          checked={values.isNew}
                          sx={{ '& .MuiSvgIcon-root': { fontSize: 70 } }}
                        />
                      }
                      label={'New'}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={3}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          color='primary'
                          name='isMostLoved'
                          onChange={(e) =>
                            setFieldValue('isMostLoved', e.target.checked)
                          }
                          checked={values.isMostLoved}
                          sx={{ '& .MuiSvgIcon-root': { fontSize: 70 } }}
                        />
                      }
                      label={'Most Loved'}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={3}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          color='primary'
                          name='isBig'
                          onChange={(e) =>
                            setFieldValue('isBig', e.target.checked)
                          }
                          checked={values.isBig}
                          sx={{ '& .MuiSvgIcon-root': { fontSize: 70 } }}
                        />
                      }
                      label={'Big'}
                    />
                  </Grid>
                </Grid>

                <Box>
                  {mergedImageUrl ? (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Box
                      onClick={() => handleOpenLightBox(mergedImageUrl)}
                      sx={{
                          position: 'relative',
                        width: '100px',
                        height: '100px',
                          m: 1,
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          bgcolor: values?.displayBackgroundColor || config.DEFAULT_COLOR,
                          overflow: 'hidden',
                          border: '1px solid #e0e0e0',
                        }}
                      >
                        <img
                          key={`img-${forceRefresh}`}
                          crossOrigin="anonymous"
                          referrerPolicy="no-referrer"
                          src={mergedImageUrl}
                          alt="Cake preview"
                          loading="eager"
                          style={{
                            maxWidth: '100%',
                            maxHeight: '100%',
                            objectFit: 'contain'
                          }}
                          onError={(e) => {
                            console.error('Image load error');
                            // Set a base64 transparent pixel as fallback
                            const target = e.target as HTMLImageElement;
                            if (!mergedImageUrl.startsWith('data:')) {
                              target.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
                            }
                          }}
                        />
                      </Box>
                      <Button 
                        size="small" 
                        variant="outlined" 
                        onClick={handleForceRefresh}
                        sx={{ height: 36, ml: 1 }}
                      >
                        Refresh
                      </Button>
                    </Box>
                  ) : (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Box 
                        sx={{ 
                          width: '100px', 
                          height: '100px', 
                          m: 1, 
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          border: '1px dashed grey',
                          bgcolor: values?.displayBackgroundColor || config.DEFAULT_COLOR
                        }}
                      >
                        <Box
                          sx={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            position: 'relative',
                          }}
                        >
                          <Box
                            sx={{
                              width: '40px',
                              height: '40px',
                              border: '3px solid #f3f3f3',
                              borderTop: '3px solid #3498db',
                              borderRadius: '50%',
                              animation: 'spin 1s linear infinite',
                              '@keyframes spin': {
                                '0%': { transform: 'rotate(0deg)' },
                                '100%': { transform: 'rotate(360deg)' }
                              }
                            }}
                          />
                        </Box>
                      </Box>
                      <Button 
                        size="small" 
                        variant="outlined" 
                        onClick={handleForceRefresh}
                        sx={{ height: 36, ml: 1 }}
                      >
                        Refresh
                      </Button>
                    </Box>
                  )}
                </Box>

                <Stack
                  alignItems='center'
                  sx={{ mt: 3 }}
                  direction='row'
                  justifyContent='flex-end'
                  gap={1}
                >
                  <Button
                    variant='outlined'
                    onClick={() => navigation('/occasion-cake')}
                  >
                    {'Cancel'}
                  </Button>

                  <LoadingButton
                    type='submit'
                    variant='contained'
                    loading={isSubmitting}
                  >
                    {isAddMode ? 'Add Occasion Cake' : 'Edit Occasion Cake'}
                  </LoadingButton>
                </Stack>
              </Card>
            </form>
          )}
        </Grid>
      </Grid>
      {openLightBox && (
        <Box
          sx={{ pt: 'env(safe-area-inset-top) !important' }}
          id='myModal'
          className='modal'
        >
          <span className='close cursor'>
            <CloseIcon
              fontSize='large'
              onClick={handleCloseLightBox}
              sx={{ mt: 'env(safe-area-inset-top) !important' }}
            />
          </span>
          <div
            className={`modal-content ${
              openLightBox ? 'display-block ' : 'display-none'
            }`}
          >
            {imageState && (
              <div className='vertical-center-div'>
                <div
                  ref={boxRef}
                  className={`mySlides ${
                    openLightBox ? 'display-block ' : 'display-none'
                  }`}
                >
                  <img
                    id={imageState}
                    src={imageState}
                    width='100%'
                    height='100%'
                    crossOrigin='anonymous'
                    alt={imageState}
                  />
                </div>
              </div>
            )}
          </div>
        </Box>
      )}
    </>
  );
};

export default CategoryCakeForm;
